
import AppColorPicker from "@/components/ColorPicker.vue";
import {TextStyledProperty, TextTransform} from "@/utils/documents/text-styled-property";
import Vue from "vue";
import { ISelectItem } from "winfakt-vue-components";
import { BasicTextStyledProperty } from "@/utils/documents/basic-text-styled-property";
import { DocumentPageSettings } from "@/utils/documents/page-settings";

export default Vue.extend({
	data() {
		return {
			toEditStyle: new TextStyledProperty(),
			availableFonts: [] as string[],
			fontInput: "",
			fontFocused: false
		};
	},
	props: {
		value: {
			type: Object as () => BasicTextStyledProperty,
			required: true
		},
		previewText: {
			type: String,
			required: false
		},
		isLocalStyle: Boolean,
		extraActions: {
			type: Array as ()=>ISelectItem<Function>[],
			default: ()=>[]
		}
	},
	computed: {
		shownFonts(): string[] {
			let input = this.fontInput.toLowerCase();
			return this.availableFonts.filter(f=>{
				return f.toLowerCase().startsWith(input);
			});
		},
		textTransformItems(): ISelectItem<TextTransform>[] {
			return [
				{
					text: this.$ct("none"),
					value: TextTransform.NONE,
				},
				{
					text: this.$ct("capitalize"),
					value: TextTransform.CAPITALIZE,
				},
				{
					text: this.$ct("uppercase"),
					value: TextTransform.UPPERCASE,
				},
				{
					text: this.$ct("lowercase"),
					value: TextTransform.LOWERCASE,
				},
				{
					text: this.$ct("full-width"),
					value: TextTransform.FULL_WIDTH,
				}
			];
		},
		transformedText(): ISelectItem<TextTransform> {
			return this.textTransformItems.filter((t: any) => t.value == this.toEditStyle.TextTransform)[0];
		},
		showExtraActions():boolean{
			return this.extraActions.length > 0;
		}
	},
	watch: {
		value: {
			immediate: true,
			handler() {
				this.toEditStyle = new TextStyledProperty(this.value);
			}
		},
		isLocalStyle: {
			immediate: true,
			async handler(){
				this.availableFonts = await DocumentPageSettings.getAvailableFonts(this.isLocalStyle);
			}
		},
		fontFocused: {
			immediate: true,
			handler(value){
				if (!value){
					this.fontInput = this.toEditStyle.Font;
				}else{
					this.fontInput = "";
				}
			}
		}
	},
	methods: {
		closeClicked() {
			this.$emit("close");
		},
		updateValue() {
			this.$emit("input", this.toEditStyle);
			this.$emit("close");
		},
		onFontInput(input:string){
			this.fontInput = input;
			this.toEditStyle.Font = input;
		}
	},
	components: {
		AppColorPicker,
	},
	i18nEx: {
		componentPrefix: "components.layout-editor"
	}
});
